import { render, staticRenderFns } from "./todays-schedule-component.vue?vue&type=template&id=7c5eb2a4&scoped=true"
import script from "./todays-schedule-component.vue?vue&type=script&lang=js"
export * from "./todays-schedule-component.vue?vue&type=script&lang=js"
import style0 from "./todays-schedule-component.vue?vue&type=style&index=0&id=7c5eb2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5eb2a4",
  null
  
)

export default component.exports